import { useEffect, useState } from "react";
import { getHero, getStatistics, getTestimonials } from "../../../api/apiServices";
import { useNavigate } from "react-router-dom";

export default function Hero() {
const navigate = useNavigate()
  const [hero, setHero] = useState(null);
  const [loading, setLoading] = useState(false);
  const [stats, setStats] = useState([]);
  const [fetching, setFetching] = useState(false);
  const [testimonials, setTestimonials] = useState([]);

  useEffect(() => {
    fetchHero();
    fetchStats();
    fetchTestimonials();
  }, []);


  const fetchHero = async () => {
    try {
      const res = await getHero();
      if (res?.data) {
        setHero(res.data);
      }
    } catch(err) {
      console.log("Error occured while fetching: ", err)
    }
  };

const fetchTestimonials = async () => {
    try {
      setFetching(true);
      const res = await getTestimonials();
      if (res?.data) {
      setTestimonials(res.data || []);
    }
    } catch (error) {
      console.error("No testimonials found");
    } finally {
      setFetching(false);
    }
    
  };

  const fetchStats = async () => {
      try {
        const res = await getStatistics();
        setStats(res.data || []);
      } catch (err) {
        console.error("Failed to fetch statistics", err);
      }
    };


  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src={hero?.backgroundImage}
          alt="Hope and Support"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-20 py-24 sm:py-32">
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-16 items-center">
          {/* Left Content */}
          <div className="text-white text-center lg:text-left">
            <div className="text-[#c9a24d] text-xs font-semibold tracking-[0.2em] uppercase mb-4 sm:mb-6">
              {hero?.subtitle}
            </div>
            
            <h1 className="font-bold leading-tight mb-6 sm:mb-8">
              <div className="text-3xl sm:text-4xl md:text-5xl lg:text-7xl mb-2">{hero?.title}</div>
              
            </h1>

            <p className="text-base sm:text-lg text-white/90 max-w-xl mx-auto lg:mx-0 mb-8 sm:mb-10 leading-relaxed">
              {hero?.description}
            </p>

            <div className="flex flex-col sm:flex-row flex-wrap gap-3 sm:gap-4 justify-center lg:justify-start">
              <button
                onClick={() => navigate('/stories')}
                className="bg-[#6a4bc3] text-white px-6 sm:px-8 py-3 sm:py-4 rounded-full font-semibold hover:bg-[#5a3ba3] transition-all hover:shadow-xl hover:-translate-y-1 flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer"
              >
                {hero?.primaryButtonText}
                <i className="ri-arrow-right-line"></i>
              </button>
              <button
                onClick={() => navigate('/volunteer')}
                className="border-2 border-[#c9a24d] text-[#c9a24d] px-6 sm:px-8 py-3 sm:py-4 rounded-full font-semibold hover:bg-[#c9a24d] hover:text-white transition-all hover:shadow-xl hover:-translate-y-1 whitespace-nowrap cursor-pointer"
              >
                {hero?.secondaryButtonText}
              </button>
            </div>
          </div>

          {/* Right Content - Image Cards (Hidden on mobile, shown on tablet+) */}
          {/* <div className="relative hidden md:block h-[400px] lg:h-[600px]">
            <div className="absolute top-0 right-0 w-48 sm:w-64 lg:w-80 h-64 sm:h-80 lg:h-96 transform rotate-3 transition-transform hover:rotate-0 hover:scale-105 duration-300">
              <div className="w-full h-full rounded-3xl overflow-hidden shadow-2xl border-4 lg:border-8 border-white">
                <img
                  src="https://readdy.ai/api/search-image?query=survivor%20success%20story%20showing%20person%20smiling%20with%20renewed%20hope%20and%20confidence%2C%20warm%20natural%20lighting%2C%20genuine%20emotion%20of%20recovery%20and%20healing%2C%20simple%20clean%20background%20emphasizing%20the%20subject%2C%20professional%20portrait%20photography%20capturing%20strength%20and%20resilience%20after%20overcoming%20crisis&width=400&height=500&seq=hero-card-001&orientation=portrait"
                  alt="Survivor Success Story"
                  className="w-full h-full object-cover object-center"
                />
              </div>
            </div>

            <div className="absolute top-16 lg:top-20 right-24 lg:right-40 w-40 sm:w-56 lg:w-72 h-56 sm:h-64 lg:h-80 transform -rotate-2 transition-transform hover:rotate-0 hover:scale-105 duration-300">
              <div className="w-full h-full rounded-3xl overflow-hidden shadow-xl border-4 lg:border-8 border-white opacity-90">
                <img
                  src="https://readdy.ai/api/search-image?query=community%20support%20group%20gathering%20with%20diverse%20people%20holding%20hands%20in%20circle%2C%20warm%20afternoon%20light%2C%20simple%20neutral%20background%2C%20showing%20unity%20and%20collective%20strength%2C%20emotional%20connection%20and%20solidarity%2C%20professional%20photography%20with%20soft%20focus%20on%20togetherness%20and%20mutual%20support&width=400&height=450&seq=hero-card-002&orientation=portrait"
                  alt="Community Support"
                  className="w-full h-full object-cover object-center"
                />
              </div>
            </div>

            <div className="absolute top-32 lg:top-40 right-48 lg:right-80 w-36 sm:w-48 lg:w-64 h-48 sm:h-56 lg:h-72 transition-transform hover:scale-105 duration-300 hidden lg:block">
              <div className="w-full h-full rounded-3xl overflow-hidden shadow-lg border-4 lg:border-8 border-white opacity-80">
                <img
                  src="https://readdy.ai/api/search-image?query=volunteers%20working%20together%20helping%20others%20with%20compassion%2C%20bright%20natural%20daylight%2C%20simple%20clean%20environment%2C%20showing%20teamwork%20and%20dedication%20to%20humanitarian%20cause%2C%20genuine%20smiles%20and%20positive%20energy%2C%20professional%20photography%20capturing%20the%20spirit%20of%20giving%20and%20service&width=400&height=450&seq=hero-card-003&orientation=portrait"
                  alt="Volunteer Activity"
                  className="w-full h-full object-cover object-center"
                />
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </section>
  );
}
